import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "@/store/store";
import { refreshPanelRequest } from "@/store/slices/dashboard.slice";

export const useDashboardPanel = (panelName: string) => {
  const dispatch = useDispatch<AppDispatch>();
  const panelLoading = useSelector(
    (state: RootState) => state.dashboard?.panelLoading?.[panelName] ?? false
  );

  const refreshPanel = useCallback(() => {
    dispatch(refreshPanelRequest({ panel: panelName }));
  }, [dispatch, panelName]);

  return {
    refreshPanel,
    isRefreshing: panelLoading,
  };
};
